'use strict';


window.addEventListener('keydown', function (e) {
    if (e.key === 'F5' || ((e.ctrlKey || e.metaKey) && e.key === 'r')) {
        console.log("F5 or Ctrl+R pressed");
        e.preventDefault();
        e.stopPropagation();
    }
});

// Force reload on bfcache restoration. When the browser restores a page from its back-forward
// cache, the AngularJS app state and service worker bridge connections are stale, so session
// resume and authentication will malfunction. A full reload re-runs app.run() to fix this.
window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
        console.log('Page restored from bfcache, forcing reload');
        window.location.reload();
    }
});



// Importing jQuery and related plugins
import $ from 'jquery';
const jQuery = $;
window.$ = $;
window.jQuery = $;
window.jquery = $;
import 'jquery-ui';
import 'jquery-colorbox';
import 'jquery.ui.widget/jquery.ui.widget';
import './libs/jquery.icheck.min';
import './vendors/jquery.texthighlighter/src/textHighlighter.js';

// Sentry
import { configureSentryAngularJsHandler, configureServiceWorkerLogForwardingToSentry } from './ib/services/sentryAngularJsHandler';
// PWA Bootstrap - handles service worker lifecycle before Angular
import PWABootstrap from './ib/pwa/PWABootstrap';
import { waitForServiceWorkerController } from './ib/pwa/serviceWorkerControllerReady';

// Initialize PWA bootstrap IMMEDIATELY (before Angular setup)
// This starts SW registration in the background while imports continue
PWABootstrap.init();

// Import Bootstrap components
import 'bootstrap-sass/vendor/assets/javascripts/bootstrap';
import 'bootstrap-sass/vendor/assets/javascripts/bootstrap/affix';
import 'bootstrap-sass/vendor/assets/javascripts/bootstrap/alert';
import 'bootstrap-sass/vendor/assets/javascripts/bootstrap/button';
import 'bootstrap-sass/vendor/assets/javascripts/bootstrap/carousel';
import 'bootstrap-sass/vendor/assets/javascripts/bootstrap/collapse';
import 'bootstrap-sass/vendor/assets/javascripts/bootstrap/dropdown';
import 'bootstrap-sass/vendor/assets/javascripts/bootstrap/modal';
import 'bootstrap-sass/vendor/assets/javascripts/bootstrap/scrollspy';
import 'bootstrap-sass/vendor/assets/javascripts/bootstrap/tab';
import 'bootstrap-sass/vendor/assets/javascripts/bootstrap/tooltip';
import 'bootstrap-sass/vendor/assets/javascripts/bootstrap/popover';
import 'bootstrap-sass/vendor/assets/javascripts/bootstrap/transition';


// Importing AngularJS and other modules
import angular from 'angular';
import 'angular-route';
import 'angular-sanitize';
import 'angular-ui-bootstrap';
import 'angular-spinner/angular-spinner';
import 'angular-moment';
import 'angular-translate';
import 'angular-dragdrop';
import 'angular-ui-select2/src/select2';
import 'angular-ui-sortable';
import 'angular-xeditable';
import 'angular-busy';
import 'angular-busy/dist/angular-busy.css';
import 'angular-filter';
import 'angular-cookies';
import 'angular-local-storage';
import 'angular-cookies';
import 'angular-animate';
import 'angular-dialog-service';
import 'angular-ui-notification';
import 'angular-resource';
import 'ngstorage';
import 'angular-elastic';
import 'angular-filter';
import 'angular-aria';



import 'd3';
import 'nvd3';
import 'blueimp-file-upload/js/jquery.fileupload-image';
import 'blueimp-file-upload/js/jquery.fileupload-angular';
//import 'blueimp-file-upload/js/jquery.fileupload-process';
import 'blueimp-file-upload';
import 'ui-autocomplete';
import 'restangular';
import 'handsontable';
import 'ng-file-upload';
import 'ng-grid/ng-grid-2.0.1.min';
import 'ng-mobile-menu/dist/ng-mobile-menu.min';
import './vendors/message-center/message-center';
import 'moment';
var _ = require('underscore');
window._ = _;

import { languages, inputLanguages } from '../languages/allLanguages';
window.languages = languages;
window.inputLanguages = inputLanguages;

import { loadStyles } from './utils/styleLoader';

import registerServices from './ib/services/';
import registerFactories from './ib/factories/';
import registerComponents from './ib/components/';
import registerModules from './ib/modules/';
import registerContentObjectDirectives from './ib/contentobjects/';
import registerFilters from './ib/filters/';
import registerBridgeClients from './ib/serviceworkerBridgeClients/index';

var applicationName = "assessmentFrontendApp";


import { setupStringPrototypeExtensions, setupAngularExtensions, setupJQuerySwap } from './utils';
setupStringPrototypeExtensions();
setupAngularExtensions(angular);
setupJQuerySwap();

var _translateProvider = null;

var assessmentFrontendProviders = angular.module('assessmentFrontendProviders', []);
var assessmentFrontendFactories = angular.module('assessmentFrontendFactories', []);


var assessmentFrontendServices = angular.module('assessmentFrontendServices', ['pascalprecht.translate', 'ui.bootstrap', 'angularMoment', 'restangular', 'ui-notification']);
registerServices(angular);
registerFactories(angular);
registerBridgeClients(angular);



var assessmentFrontendFilters = angular.module('assessmentFrontendFilters', []);
var assessmentFrontendDirectives = angular.module('assessmentFrontendDirectives', ['assessmentFrontendFilters']);
assessmentFrontendDirectives.value('$', window.jQuery);
var assessmentFrontendControllers = angular.module('assessmentFrontendControllers', [
    'assessmentFrontendProviders',
    'assessmentFrontendFactories',
    'assessmentFrontendServices'
]);

registerComponents(angular);
registerModules(angular);
registerContentObjectDirectives(angular);
registerFilters(angular);
var assessmentFrontendApp = angular.module(applicationName, [
    'assessmentFrontendFactories',
    'assessmentFrontendControllers',
    'assessmentFrontendDirectives',
    'ngRoute',
    'ngSanitize',
    'ui.bootstrap',
    'angularSpinner',
    'angularMoment',
    'pascalprecht.translate',
    'ngDragDrop',
    'ngGrid',
    'shoppinpal.mobile-menu',
    'blueimp.fileupload',
    'ui.select2',
    'ui.autocomplete',
    'ui.sortable',
    'xeditable',
    'cgBusy',
    //    'IB.Admin',
    'ngStorage',
    'ngCookies',
    'ngAnimate',
    'dialogs.main',
    'ui-notification',
    //'IB.Reports'
]);

assessmentFrontendApp.config(['$compileProvider', function ($compileProvider) {
    $compileProvider.imgSrcSanitizationWhitelist(/^\s*(https?|ftp|mailto|file|asset):/);
}]);


// Detect CMS and push info onto root scope
var isCMS = window.location.href.indexOf("index-cms") > -1 || window.location.href.indexOf("index-pdf") > -1 || window.location.href.indexOf("exam-export-pdf") > -1;
window.isCMS = isCMS;

var CMSSession = null;

window.IB = {}
window.IB.iFrameDelegates = {};
window.IB.Signals = {
    BEFORE_SHEET_BLUR: 'beforeSheetBlur',
    MODELCHANGE: 'modelchange',
    SHOW_MODAL: 'showModal',
    MODAL_DID_CLOSE: 'modalDidClose',
    SHEET_WAIT_REQUEST: 'sheetWaitRequest',
    SHEET_WAIT_REQUEST_CLOSED: 'sheetWaitRequestClosed',
    AUTO_SAVE: 'autosave',
    DISPLAY_TRIGGER: 'displayTrigger',
    QUESTION_SPOILED: 'questionSpoiled',
    UPLOAD_SERVICE_FILE_ADDED: 'uploadServiceFileAdded',
    UPLOAD_SERVICE_UPLOAD_FAILED: 'uploadServiceFileUploadFailed',
    UPLOAD_SERVICE_REMOVE_FROM_QUEUE: 'uploadServiceRemoveFileFromList',
    UPLOAD_SERVICE_UPLOAD_FINISHED: 'uploadServiceFileUploadFinished',
    UPLOAD_SERVICE_UPLOAD_FINISHED_COPIED_CONTAINER: 'uploadServiceFileUploadFinishedCopiedContainer',
    REPOSITORY_ADD_FILE_AND_REFRESH: 'repositoryAddFileAndRefreshMediaList',
    REPOSITORY_MEDIALIST_CHANGE: 'repositoryMediaListChange',
    REPOSITORY_UPDATE_OBJECT: 'repositoryUpdateObjectData',
    USER_FILE_LOADED: 'userFileLoaded',
    RESPONSE_INITIALIZED: 'initResponseCompleted',
    RESPONSE_INIT_FAILED: 'initResponseFailed',
    UPDATE_ZOOM_LEVEL: 'updateZoomLevel',
    CMS_MEDIA_OBJECT_SELECTED: 'MediaObjectSelected',
    UNIVERSALCANVAS_PALETTE_CHANGE: 'UniversalCanvasPaletteHasChanged',
    ADD_SCE_WHITELIST: 'addSCEwhitelist'
};
//all times in millisecons
window.IB.timers = {
    maxReadingTime: 0,      //  300000  5 minutes
    maxJournalTime: 600000,       //  600000  10 minutes
    finishEarlyTime: 3600000,       // 3600000 60 minutes
    finishEarlyTimeMin: 900000,       // 900000 15 minutes
    inactivityTimeoutIdleTime: 10 * 60 * 1000  // 10 minutes
};



(function (angular, app) {

    configureSentryAngularJsHandler(app);


    /**
     * Return promise to load taskData via TaskDataService
     */
    var taskDataResolver = function (TaskDataService, $q, $location, $bridges) {
        var delay = $q.defer();

        // fetch context loads taskdata info ram
        TaskDataService.fetchContext(function (context, error) {
            if (error) {
                var redirect = '/';
                if (isCMS)
                    redirect = '/list';

                $location.path(redirect);
                $bridges.logger().error('Failed to load repository');
                delay.reject();
            }

            delay.resolve(context);
            return context;
        });

        return delay.promise;
    };

    var taskDataAndScriptsResolver = function (TaskInfoService, TaskDataService, $q, $location, $bridges) {
        var defer = $q.defer();
        var promises = [];

        promises.push(taskDataResolver(TaskDataService, $q, $location, $bridges));
        promises.push(taskScriptsResolver(TaskInfoService, $q));

        $q.all(promises).then(function () {
            defer.resolve();
        });

        return defer.promise;
    };

    /**
     * Return promise to load taskInfo via TaskInfoService
     */
    var taskInfoResolver = ['TaskInfoService', '$q', function (TaskInfoService, $q) {
        console.warn('taskInfoResolver called');
        var defer = $q.defer();
        TaskInfoService.loadTaskInfo(function (taskInfo) {
            defer.resolve();
            return taskInfo;
        });
        return defer.promise;
    }];


    /**
     * Return promise to load cached assessment archive
     */
    var cachedAssessmentResolver = ['PWAService', '$q', function (PWAService, $q) {
        /*return PWAService.loadCachedAssessmentArchive().catch(error => {
            console.error('Failed to load cached assessment archive:', error);
            // Still returns a resolved promise, maintaining the promise chain
            return Promise.resolve();
        });*/
    }];

    var cachedAuthenticationResolver = ['$q', 'AuthenticationBridgeClient', function ($q, AuthenticationBridgeClient) {
        var defer = $q.defer();
        if (AuthenticationBridgeClient.isUnlocked()) {
            defer.resolve();
        } else {
            if (AuthenticationBridgeClient.restoreAuthenticatedUser) {
                var restored = AuthenticationBridgeClient.restoreAuthenticatedUser();
                if (restored) {
                    defer.resolve();
                } else {
                    defer.reject();
                }
            } else {
                defer.resolve();
            }
        }
        return defer.promise;
    }];


    /**
     * Return promise to load scripts defined in TaskInfo
     */
    var taskScriptsLoaded = false;

    var taskScriptsResolver = function (TaskInfoService, $q) {

        var taskInfo = TaskInfoService.getTaskInfo();

        // Already loaded or no scripts? Return pre-resolved promise
        var noScripts = !angular.isDefined(taskInfo.getTaskScriptFiles()) || !angular.isArray(taskInfo.getTaskScriptFiles()) || taskInfo.getTaskScriptFiles().length == 0;
        if (taskScriptsLoaded === true || noScripts) {
            var defer = $q.defer();
            defer.resolve();
            return defer.promise;
        }


        // Create a promise per script to be loaded

        var scriptPromises = [];
        for (var idx in taskInfo.getTaskScriptFiles()) {
            var defer = $q.defer();
            scriptPromises.push(defer);

            var taskScriptFile = taskInfo.getTaskScriptFiles()[idx];

            $.getScript("/taskcontent/" + taskScriptFile, function () {
                defer.resolve();
            });

        }

        // Flag as loaded
        taskScriptsLoaded = true;

        return $q.all(scriptPromises);
    };

    /**
     * Return promise to load taskInfo via TaskInfoService, taskData via TaskDataService, task specific scripts via taskScriptsResolver ...
     * Promise resolves to taskData in the end
     */
    var taskInfoAndTaskDataResolver = function (TaskDataService, TaskInfoService, $q, $timeout, $location, $bridges) {
        console.log("taskInfoAndTaskDataResolver called");
        var defer = $q.defer();
        // If we don't have taskinfo yet, load this first, then promise to load taskData
        if (TaskInfoService.getTaskInfo() == null) {
            console.log("taskInfoAndTaskDataResolver: taskInfo is null, resolving taskInfo");
            taskInfoResolver(TaskInfoService, $q).then(function () {
                console.log("taskInfoAndTaskDataResolver: taskInfo resolved, resolving taskDataAndScriptsResolver");
                taskDataAndScriptsResolver(TaskInfoService, TaskDataService, $q, $location, $bridges).then(function () {
                    console.log("taskInfoAndTaskDataResolver: taskDataAndScriptsResolver resolved, resolving taskInfoAndTaskDataResolver");
                    defer.resolve();
                });
            });
            console.log('taskInfoAndTaskDataResolver: returning defer.promise');
            return defer.promise;
        }
        taskDataAndScriptsResolver(TaskInfoService, TaskDataService, $q, $location, $bridges).then(function () {
            console.log('taskInfoAndTaskDataResolver: taskDataAndScriptsResolver resolved, resolving taskInfoAndTaskDataResolver');
            defer.resolve();
        });
        console.log('taskInfoAndTaskDataResolver: returning defer.promise');
        return defer.promise;
    };

    /**
     * Return promise to load user info via UserInfoService
     * Takes user UUID either from route param (preferred) or auth bridge
     * @param {boolean} startTask Start the task via TaskFlowService.ensureTaskIsStarted() after userInfo was loaded?
     */
    var timeSetupAlreadyDone = false,
        userInfoResolverFactory = function (startTask, initResponse, setupTime, hasExistingData) {
            return ['UserInfoService', 'TaskFlowService', '$q', '$translate', '$route', 'AuthenticationBridgeService', '$rootScope', '$timeout', function (UserInfoService, TaskFlowService, $q, $translate, $route, AuthenticationBridgeService, $rootScope, $timeout) {
                console.log('userInfoResolver: ENTERED - startTask:', startTask, 'initResponse:', initResponse, 'setupTime:', setupTime);
                console.log('userInfoResolver: $rootScope.sessionResumePromise at entry:', $rootScope.sessionResumePromise ? 'EXISTS' : 'NOT SET');

                var defer = $q.defer();

                // The main resolver logic - separated so we can wait for session resume first if needed
                var proceedWithResolver = function () {
                    var uuidRoute = $route.current.params.UserUUID,
                        uuidAuth = AuthenticationBridgeService.getUserUUID(),
                        uuid = angular.isDefined(uuidRoute) ? uuidRoute : uuidAuth; // prefer user uuid from route, otherwise a re-login is not possible

                    console.log('userInfoResolver: proceedWithResolver - uuidRoute:', uuidRoute, 'uuidAuth:', uuidAuth, 'uuid:', uuid);

                    if (typeof (uuid) == 'undefined') {
                        console.log('userInfoResolver: uuid is still undefined, resolving empty');
                        defer.resolve();
                        return;
                    }

                    $rootScope.rp = defer;
                    if (isCMS) {
                        defer.minDuration = 0;
                        defer.delay = 1000;
                    }
                    defer.message = $translate.instant("LOADER.LOAD-USER-DATA");

                    // Resolve via UserInfoService
                    console.log('userInfoResolver: Calling UserInfoService.loadUserInfo for uuid:', uuid);
                    UserInfoService.loadUserInfo(uuid, function (currentUser) {
                        console.log('userInfoResolver: loadUserInfo callback entered, currentUser:', currentUser ? currentUser.getType() : 'null');
                        if ($rootScope.invigilatorLogin && currentUser.getType() != 'invigilator') {
                            $rootScope.invigilatorUnlockFailed = true;
                            defer.reject();
                            return currentUser;
                        }

                        var postInit = function () {
                            if (setupTime && !timeSetupAlreadyDone) {
                                TaskFlowService.setupTaskTime(currentUser);
                                timeSetupAlreadyDone = true;
                            }
                            if (startTask) {
                                TaskFlowService.ensureTaskIsStarted();
                            }
                            defer.resolve();
                        };

                        var doInitResponse = function () {
                            if (initResponse || (angular.isDefined(hasExistingData) && hasExistingData === true)) {
                                console.log('userInfoResolver: calling checkAndInitResponse');
                                TaskFlowService.checkAndInitResponse(currentUser, initResponse).then(postInit, null, function (msg) {
                                    defer.message = msg;
                                });
                            } else {
                                postInit();
                            }
                        };

                        doInitResponse();

                    }, function () {
                        defer.resolve();
                        return null;
                    });
                };

                // If session resume is in progress, wait for it FIRST before trying to get UUID
                // This is critical because the user won't be authenticated until session resume completes
                if ($rootScope.sessionResumePromise) {
                    console.log('userInfoResolver: sessionResumePromise EXISTS, waiting for it before proceeding');
                    $rootScope.sessionResumePromise.then(function () {
                        console.log('userInfoResolver: sessionResumePromise RESOLVED, now calling proceedWithResolver');
                        proceedWithResolver();
                    }).catch(function (err) {
                        console.error('userInfoResolver: sessionResumePromise REJECTED:', err);
                        // Check if we have any auth state despite the failure
                        if (!AuthenticationBridgeService.getUserUUID()) {
                            console.error('userInfoResolver: No authentication state after resume failure, resolving empty');
                            defer.resolve();
                            return;
                        }
                        // User might have partial auth state, try to proceed cautiously
                        console.log('userInfoResolver: Auth state exists despite resume failure, proceeding cautiously');
                        proceedWithResolver();
                    });
                } else {
                    console.log('userInfoResolver: No sessionResumePromise, calling proceedWithResolver immediately');
                    proceedWithResolver();
                }

                return defer.promise;
            }];
        }; // userInfoResolverFactory()

    var taskInfoResolver = function (TaskInfoService, $q) {

        var defer = $q.defer();
        TaskInfoService.loadTaskInfo(function (taskInfo) {


            initInputLanguage(taskInfo, $q).then(function () {
                defer.resolve();
            });

            return taskInfo;
        }, function () {
            defer.reject();
            return false;
        });
        return defer.promise;
    };

    var versioningAndLockingResolver = ['VersioningAndLockingService', '$route', '$q', function (VersioningAndLockingService, $route, $q) {
        var defer = $q.defer();
        VersioningAndLockingService.loadData($route.current.params.taskUUID, true).then(function () {
            defer.resolve();
        });
        return defer.promise;
    }];

    /**
     * Return promise to load taskInfo via TaskInfoService, taskData via TaskDataService, task specific scripts via taskScriptsResolver ...
     * Promise resolves to taskData in the end
     */
    var responseDataResolver = ['ResponseDataLoaderService', '$route', '$q', '$timeout', function (ResponseDataLoaderService, $route, $q, $timeout) {

        var uuid = $route.current.params.UserUUID,
            schoolCode = $route.current.params.schoolCode,
            responseFolderName = $route.current.params.responseFolderName,
            defer = $q.defer();
        if (typeof (uuid) == 'undefined') return;
        // Resolve via UserInfoService
        ResponseDataLoaderService.loadResponseData(uuid, schoolCode, responseFolderName, function () {
            defer.resolve();
        });
        return defer.promise;
    }];

    var examSessionSelectionResolver = ['ExamSessionSelectionService', '$q', function (ExamSessionSelectionService, $q) {
        var d = $q.defer();
        ExamSessionSelectionService.getSessionOptions().then(function () {
            d.resolve();
        });
        return d.promise;
    }];

    /**
     * Check for valid CMS session
     */
    var cmsSessionResolver = ['$q', '$location', '$http', '$rootScope', 'UserInfoService', 'CMSUser', '$uibModal', 'NotificationService', function ($q, $location, $http, $rootScope, UserInfoService, CMSUser, $uibModal, NotificationService) {
        var defer = $q.defer();

        console.info("Resolving CMS session...");

        var _successCallback = function (currentUser, userUUID, response) {
            console.info("Got response for session: ", response);
            if (response.success) {
                $rootScope.CMSSession = response.session;
                CMSSession = response.session;
                $rootScope.loginType = response.session.type;
                console.info("Session is now: ", $rootScope.CMSSession);

                if ($rootScope.CMSSession.type === 'SCHOOL') {
                    if (!$rootScope.CMSSession.firstName || !$rootScope.CMSSession.lastName) {
                        var instance = $uibModal.open({
                            templateUrl: '/scripts/admin/auth/registration/views/registration.html',
                            controller: 'IB.Admin.Auth.Registration.RegistrationController',
                            keyboard: false,
                            backdrop: 'static'
                        });

                        instance.result.then(function (success) {
                            if (success) {
                                defer.resolve();
                            } else {
                                defer.reject();
                            }
                        });
                    } else {
                        defer.resolve();
                    }
                } else {
                    NotificationService.init();
                    defer.resolve();
                }
            }
        };

        var _errorCallback = function (currentUser, userUUID, response) {
            console.error("Unable to get session: ", response);
            $rootScope.adminLoadingMessage = 'Unable to get session!';

            $rootScope.CMSSession = false;
            console.log("location.path ", $location.path())
            if ($location.path().indexOf('/cms/start/') != 0) {
                if (typeof btoa == 'function') {
                    $location.path('/cms/start/' + btoa($location.path()));
                } else {
                    $location.path('/cms/start/');
                }
            }

            defer.resolve();
        };

        UserInfoService.loadUserInfo('', _successCallback, _errorCallback);

        return defer.promise;
    }];

    var clearTask = ['TaskInfoService', 'TaskSelectionService', 'TaskDataService', '$objectCache', '$translate', function (TaskInfoService, TaskSelectionService, TaskDataService, $objectCache, $translate) {
        TaskDataService.clear();
        TaskInfoService.clear();
        TaskSelectionService.clear();
        $objectCache.clear();
        $translate.use('en_US');

        angular.forEach(languages, function (value, key) {
            _translateProvider.translations(key, value);
        });
    }];

    /**
     * Unlock the assessment in CMS mode
     */
    var cmsUnlockResolver = ['$bridges', '$q', '$location', function ($bridges, $q, $location) {
        var authentication = $bridges.authentication(),
            defer = $q.defer();

        authentication.cms_tryUnlockSynchronous(authentication.getMockUserUnlockCode(), function () {
            defer.resolve();
        });

        return defer.promise;
    }];

    var VMDetectionResolver = ['$q', 'VMDetectionService', function ($q, VMDetectionService) {

        var defer = $q.defer();

        VMDetectionService.init().then(function () {
            defer.resolve();
        },
            function () {
                defer.resolve();
            })

        return defer.promise;
    }];


    var schoolResolver = ['$q', '$translate', '$route', 'UserInfoService', 'IB.Admin.Model.School', '$rootScope', '$cookieStore', 'APIService',
        function ($q, $translate, $route, UserInfoService, School, $rootScope, $cookieStore, APIService) {
            var defer = $q.defer();

            var school_code = $route.current.params.school_code;

            function getSchoolOne(School, school_code) {
                $rootScope.adminLoadingMessage = $translate.instant('ADMIN-UI.PROGRESS.SCHOOL_DATA');
                return School.one(school_code).get();
            }

            getSchoolOne(School, school_code).then(function (school) {
                if (!UserInfoService.getUserInfo()) {
                    $rootScope.adminLoadingMessageError = "User data not found!";
                    return;
                }
                if (UserInfoService.getUserInfo().getType() === 'SCHOOL') {
                    var languageCode = school.language.iso_code_short + '_' + school.language.locale.toUpperCase();
                    $rootScope.adminUI = true;

                    if ($cookieStore.get('selectLanguage')) {
                        APIService.getLanguage().then(function (data) {
                            var languageObj = _.where(data, { isoCodeShort: $cookieStore.get('selectLanguage') });
                            languageObj = languageObj[0];
                            var _isoLanguage = languageObj.isoCodeShort + '_' + languageObj.locale.toUpperCase();
                            $translate.use(_isoLanguage);
                        });
                    } else {
                        $translate.use(languageCode);
                    }

                }

                defer.resolve(school);

            }, function (err) {
                $rootScope.adminLoadingMessageError = "Error reading school data (" + err.status + " " + err.statusText + ")";
                console.error("Error reading admin school data", err, arguments);
            });

            return defer.promise;
        }
    ];


    /**
     * Return promise to load optionsFile via OptionsService
     */
    var loadOptionsFile = ['$options', '$q', function ($options, $q) {
        var defer = $q.defer();

        $options.loadOptionsFile(function () {
            defer.resolve();
            return;
        });

        return defer.promise;
    }]; // loadOptionsFile()

    /**
     * Resolve when service worker initialization is complete.
     * Since PWABootstrap.ready() was awaited in bootstrap(), this primarily serves
     * as a route resolver dependency. The SW may not be active if unsupported.
     */
    var serviceWorkerControlResolver = ['$q', function ($q) {
        var defer = $q.defer();
        PWABootstrap.ready().then(function (result) {
            // Always resolve - app can function without SW (degraded mode)
            // The result.supported flag indicates if SW is actually active
            defer.resolve(result);
        }).catch(function (error) {
            // Should not happen as PWABootstrap.ready() never rejects,
            // but handle it gracefully just in case
            console.error('serviceWorkerControlResolver: Unexpected rejection:', error);
            defer.resolve({ supported: false, error: error });
        });
        return defer.promise;
    }];

    /**
     * To resolve before PWA start page is shown
     */
    var pwaStartResolve = {
        serviceWorkerControl: serviceWorkerControlResolver,
        clearTask: clearTask
    }

    /**
     *
     * @type {{VMDetectionResolver: VMDetectionResolver}}
     */
    var VMDetectionResolve = {
        "VMDetection": VMDetectionResolver
    };

    /**
     * Promise factories to trigger before login
     */
    var beforeLoginResolve = {
        serviceWorkerControl: serviceWorkerControlResolver,
        cachedAssessment: cachedAssessmentResolver,
        taskInfo: taskInfoResolver,
    };

    /**
     * Promise factories to trigger after login but before task started
     * @type {Object}
     */
    var helloUserResolve = {
        serviceWorkerControl: serviceWorkerControlResolver,
        cachedAuthentication: cachedAuthenticationResolver,
        cachedAssessment: cachedAssessmentResolver,
        taskInfo: taskInfoResolver,
        userInfo: userInfoResolverFactory(false, false, false),


    };

    var instructionsResolve = {
        serviceWorkerControl: serviceWorkerControlResolver,
        cachedAuthentication: cachedAuthenticationResolver,
        cachedAssessment: cachedAssessmentResolver,
        taskInfo: taskInfoResolver,
        userInfo: userInfoResolverFactory(false, true, true),
        taskData: taskInfoAndTaskDataResolver,
        loadOptions: loadOptionsFile
    };

    /**
     * Promise CMS session is available
     */
    var cmsSessionResolve = {
        cmsSession: cmsSessionResolver,
        clearTask: clearTask
    };

    var cmsSessionResolveWithExamSessionSelection = {
        cmsSession: cmsSessionResolver,
        clearTask: clearTask,
        examSessionSelection: examSessionSelectionResolver
    };

    var adminDetailResolve = {
        cmsSession: cmsSessionResolver,
        schoolResolve: schoolResolver
    };

    /**
     * Promises for invigilator/admin menu
     */
    var adminResolve = {
        taskInfo: taskInfoResolver,
        userInfo: userInfoResolverFactory(false, true, false),
        taskData: taskInfoAndTaskDataResolver
    };



    /**
     * Promise factories to trigger during the task
     * @type {Object}
     */
    var duringTaskControllerResolve = {
        cachedAuthentication: cachedAuthenticationResolver,
        cachedAssessment: cachedAssessmentResolver,
        taskInfo: taskInfoResolver,
        userInfo: userInfoResolverFactory(true, true, true),
        taskData: taskInfoAndTaskDataResolver
    };

    /**
     * Promise factories to trigger after the task
     * @type {Object}
     */
    var afterTaskControllerResolve = {
        cachedAuthentication: cachedAuthenticationResolver,
        cachedAssessment: cachedAssessmentResolver,
        taskInfo: taskInfoResolver,
        userInfo: userInfoResolverFactory(false, false, false),
        taskData: taskInfoAndTaskDataResolver
    };

    /**
     * Promise factories to trigger for PDFController
     * @type {Object}
     */
    var pdfResolve = {
        cmsSession: cmsSessionResolver,
        unlock: cmsUnlockResolver,
        taskInfo: taskInfoResolver,
        userInfo: userInfoResolverFactory(true, true, false),
        taskData: taskInfoAndTaskDataResolver
    };

    /**
     * Load Languages
     */
    var loadLanguage = function ($translateProvider) {
        if (angular.isDefined(languages)) {
            angular.forEach(languages, function (value, key) {
                $translateProvider.translations(key, value);
                if (isCMS) {
                    var _tmp = {};
                    _tmp['CONTENT.MARKPLACEHOLDER-' + key] = $translateProvider.translations(key)['CONTENT.MARK'];
                    $translateProvider.translations('en_US', _tmp);
                }
            });
            if (isCMS) {
                angular.forEach(inputLanguages, function (value, key) {
                    $translateProvider.translations(key, value);
                    var _tmp = {}
                    _tmp['CONTENT.MARKPLACEHOLDER-' + key] = $translateProvider.translations(key)['CONTENT.MARK'];
                    $translateProvider.translations('en_US', _tmp);
                });
            }
        }
        $translateProvider.fallbackLanguage('en_US');
        $translateProvider.preferredLanguage('en_US');

        _translateProvider = $translateProvider;
    };

    var setCustomMarks = function (taskInfo) {
        if (taskInfo.getCustomMarkLabel() && taskInfo.getCustomMarksLabel()) {
            var mark = {
                'CONTENT.MARK': "{{totalMarks > 1 && '" + taskInfo.getCustomMarksLabel() + "' || '" + taskInfo.getCustomMarkLabel() + "'}}"
            };
            angular.forEach(languages, function (value, key) {
                if (isCMS) {
                    _translateProvider.translations('preview_' + key, mark);
                }
                _translateProvider.translations(key, mark);
            });
        }
    };
    var initInputLanguage = function (taskInfo, $q, $route) {
        var defer = $q.defer();

        if (isCMS) {
            angular.forEach(languages, function (value, key) {
                _translateProvider.translations('preview_' + key, value);
            });
        }
        if (taskInfo.isInputLanguageCode()) {

            var inputLanguageISO = taskInfo.getISOInputLanguageCode();


            //$.getScript("../languages/inputLanguages/" + inputLanguageISO + ".js").done(function (script, textStatus) {
            if (!angular.isDefined(inputLanguages[inputLanguageISO])) {
                taskInfo.setInputLanguage(taskInfo.getLanguageCode());
                taskInfo.setSpellcheckerLanguageCode(taskInfo.getLanguageCode());
                defer.resolve();
                return defer.promise;
            }

            angular.forEach(languages, function (value, key) {
                if (isCMS) {
                    _translateProvider.translations('preview_' + key, inputLanguages[inputLanguageISO]);
                    _translateProvider.translations(key, inputLanguages[inputLanguageISO]);
                } else {
                    _translateProvider.translations(key, inputLanguages[inputLanguageISO]);
                }
            });

            setCustomMarks(taskInfo);

            defer.resolve();
            //}).fail(function(){
            //    defer.resolve();
            //});
        } else {
            setCustomMarks(taskInfo);

            defer.resolve();
        }


        return defer.promise;
    };


    const stylesPromise = loadStyles();

    var bootstrap = async function (angular, route, locationProvider) {
        console.log("bootstrap -> waiting for styles");
        await stylesPromise;

        console.log("bootstrap -> waiting for service worker");
        // PWABootstrap was already initialized at module load time,
        // so this just waits for it to complete
        const swResult = await PWABootstrap.ready();
        console.log("bootstrap -> service worker ready:", swResult);

        if (swResult.supported) {
            configureServiceWorkerLogForwardingToSentry();
        }

        bootstrap2(angular, route, locationProvider);
    }

    /**
     * Bootstrap services and global message handlers
     */
    var bootstrap2 = function (angular, route, locationProvider) {



        // boostrap loading of persistent services
        var injector = angular.injector(['assessmentFrontendServices']),
            $objectCache = injector.get('$objectCache'),
            $signals = injector.get('$signals'),
            $store = injector.get('DataBridgeService'),
            runtimeBridge = injector.get('BridgeRuntimeService'),
            taskCountdownService = injector.get("TaskCountdownService"),
            // errorHandlerService     = injector.get('ErrorHandlerService'),
            taskCountdownModel = taskCountdownService.getInstance();

        // Transfer messages from native runtime into signal
        window.assessmentFrontendMessage = $signals.emit.bind($signals);
        window.signals = $signals;

        // Let runtime know that the app is ready!
        runtimeBridge.frontendReady();

        if (!isCMS) {
            setInterval(function () {
                $signals.emit(IB.Signals.AUTO_SAVE);
            }, 28000);
        } else {
            console.info("CMS Mode detected, omitting auto_save interval.");
        }

        $signals.on(IB.Signals.ADD_SCE_WHITELIST, function (url) {
            console.log("Adding URL to SCE whitelist: ", url);
            var whitelist = sceDelegateProviderTmp.resourceUrlWhitelist();
            whitelist.push(url);
            sceDelegateProviderTmp.resourceUrlWhitelist(whitelist);
        });

        // register event for disabling history back with backspace
        $(document).keydown(function (evnt) {
            var textElementFocus = $(document.activeElement).is("input:focus, textarea:focus"),
                richTextElemenFocus = $(document.activeElement).is("rich-text-editor:focus"),
                richTextInlineElementFocus = $(document.activeElement).is("div:focus") && $(document.activeElement).hasClass("cke_editable_inline"),
                allowHistoryBack = true,
                BACKSPACE = 8;

            if (evnt.keyCode === BACKSPACE) {
                if (!textElementFocus && !richTextElemenFocus && !richTextInlineElementFocus) {
                    allowHistoryBack = false;
                }
            }

            return allowHistoryBack;
        });

    };

    /**
     * Configure IB Angular app
     */
    var sceDelegateProviderTmp;

    app.config(['$routeProvider', '$locationProvider', '$sceDelegateProvider', '$translateProvider', '$httpProvider', 'fileUploadProvider', '$compileProvider',

        function (route, locationProvider, $sceDelegateProvider, $translateProvider, $httpProvider, fileUploadProvider, $compileProvider) {

            locationProvider.hashPrefix('');

            $httpProvider.interceptors.push(function ($rootScope, $injector) {
                var loginModal = function (response) {
                    if (response.status == 401) {
                        var CheckLoginService = $injector.get('CheckLoginService'); // prevents angular::cdep error
                        $rootScope.CMSSession = false;
                        CheckLoginService.openModal();
                    }

                    return response;
                };

                return {
                    'response': loginModal
                }
            });


            $sceDelegateProvider.resourceUrlWhitelist(['.*', 'self']);
            sceDelegateProviderTmp = $sceDelegateProvider;

            bootstrap(angular, route, locationProvider);

            if (!isCMS) {
                $compileProvider.aHrefSanitizationWhitelist(/^\s*(asset|https?):/);
            }
            // configure routes
            if (isCMS) {

                angular.extend(fileUploadProvider.defaults, {
                    dataType: 'json',
                    autoUpload: false,
                    sequentialUploads: true
                });

                // without this jQuery won't load blob images for Uploader Manager
                // var oldWhiteList = $compileProvider.imgSrcSanitizationWhitelist();
                $compileProvider.imgSrcSanitizationWhitelist(/^\s*(https?|blob):|data:image\//);
                // $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?):/);

                //
                $httpProvider.defaults.xsrfCookieName = 'csrftoken';
                $httpProvider.defaults.xsrfHeaderName = 'X-CSRFToken';

                route
                    .when('/list', {
                        templateUrl: '/views/ib/cms/eassessment/eassessmentlist.html',
                        //controller: 'EAssessmentListController'
                        resolve: cmsSessionResolve
                    })
                    .when('/create', {
                        templateUrl: '/views/ib/cms/eassessment/eassessmentcreate.html',
                        //controller: 'EAssessmentCreateController'
                        resolve: cmsSessionResolve
                    })
                    .when('/export-ibis-ms', {
                        templateUrl: '/views/ib/cms/exportIbisMS/exportIbisMSList.html',
                        controller: 'ExportIbisMSListController',
                        resolve: cmsSessionResolve
                    })
                    .when('/export-ibis-ms-details/:noLangCode/:session', {
                        templateUrl: '/views/ib/cms/exportIbisMS/exportIbisMSDetailedList.html',
                        controller: 'ExportIbisMSDetailedListController',
                        resolve: cmsSessionResolve
                    })
                    .when('/wrap-and-deploy-list', {
                        templateUrl: '/views/ib/cms/wrapAndDeploy/wrapanddeploylist.html',
                        controller: 'WrapAndDeployListController',
                        resolve: cmsSessionResolveWithExamSessionSelection
                    })
                    .when('/wrap-and-deploy-details/:taskUUID', {
                        templateUrl: '/views/ib/cms/wrapAndDeploy/wrapanddeployDetailsOverview.html',
                        controller: 'WrapAndDeployDetailsOverviewController',
                        resolve: cmsSessionResolve
                    })
                    .when('/list/page:page', {
                        templateUrl: '/views/ib/cms/eassessment/eassessment.html',
                        controller: 'EAssessmentListController',
                        resolve: cmsSessionResolve
                    })
                    .when('/details/:id', {
                        templateUrl: '/views/ib/cms/eassessment/eassessment.html',
                        controller: 'EAssessmentListController',
                        resolve: cmsSessionResolve
                    })
                    .when('/mediamanager/:taskUUID', {
                        templateUrl: '/views/ib/cms/eassessment/eassessmentmediamanager.html',
                        controller: 'EAssessmentMediaManagerController',
                        resolve: duringTaskControllerResolve
                    })
                    .when('/mediamanager/:taskUUID/:returnTo', {
                        templateUrl: '/views/ib/cms/eassessment/eassessmentmediamanager.html',
                        controller: 'EAssessmentMediaManagerController',
                        resolve: duringTaskControllerResolve
                    })
                    .when('/instructions/:taskUUID/:returnTo', {
                        templateUrl: '/views/ib/cms/createInstructions/CreateInstructions.html',
                        controller: 'CMSInstructionsController',
                        resolve: duringTaskControllerResolve
                    })
                    .when('/instructions/:taskUUID', {
                        templateUrl: '/views/ib/cms/createInstructions/CreateInstructions.html',
                        controller: 'CMSInstructionsController',
                        resolve: duringTaskControllerResolve
                    })
                    .when('/overview/:taskUUID/:preview', {
                        // TODO: just for develoment!
                        templateUrl: '/views/ib/modules/overview/Overview.html',
                        controller: 'OverviewController',
                        resolve: duringTaskControllerResolve
                    })
                    .when('/reports/anomalies', {
                        controller: 'IB.Reports.Anomalies.List.IndexController',
                        templateUrl: '/scripts/reports/anomalies/views/list/index.html',
                        resolve: cmsSessionResolve
                    })
                    .when('/reports', {
                        redirectTo: '/reports/anomalies',
                    })
                    .when('/admin-ui/list/', {
                        controller: 'IB.Admin.Assessment.List.IndexController',
                        templateUrl: '/scripts/admin/assessment/views/list/index.html',
                        resolve: cmsSessionResolveWithExamSessionSelection
                    })
                    .when('/admin-ui/list/assessment/:school_code', {
                        controller: 'IB.Admin.Assessment.List.AssessmentController',
                        templateUrl: '/scripts/admin/assessment/views/list/assessment.html',
                        resolve: cmsSessionResolve
                    })
                    .when('/admin-ui/list/school/:assessment_id', {
                        controller: 'IB.Admin.Assessment.List.SchoolController',
                        templateUrl: '/scripts/admin/assessment/views/list/school.html',
                        resolve: cmsSessionResolve
                    })
                    .when('/admin-ui/assessment/detail/:assessment_id/:school_code', {
                        controller: 'IB.Admin.Assessment.Detail.IndexController',
                        templateUrl: '/scripts/admin/assessment/views/detail/index.html',
                        resolve: adminDetailResolve
                    })
                    .when('/admin-ui/list/compcheck-results/:school_code', {
                        controller: 'CompcheckResultsComponent',
                        templateUrl: '/scripts/admin/compcheck-report/views/compcheck-results.component.html',
                        resolve: cmsSessionResolve
                    })
                    .when('/pdf/:taskUUID/:sheetUUID', {
                        templateUrl: '/views/ib/modules/pdf/PDFResponse.html',
                        controller: 'PDFResponseController',
                        resolve: pdfResolve
                    }).when('/pdf/:taskUUID/:sheetUUID/:pagebreak', {
                        templateUrl: '/views/ib/modules/pdf/PDFResponse.html',
                        controller: 'PDFResponseController',
                        resolve: pdfResolve
                    }).when('/pdf/:taskUUID/:sheetUUID/qpart/:questionPartUUID', {
                        templateUrl: '/views/ib/modules/pdf/PDFResponse.html',
                        controller: 'PDFResponseController',
                        resolve: pdfResolve
                    }).when('/exam-export/:taskUUID/:sheetUUID?', {
                        templateUrl: '/scripts/ib/components/cms/examExportComponent/views/exam-export-pdf.component.html',
                        controller: 'ExamExportPDFComponent',
                        resolve: pdfResolve
                    })
                    .when("/school/start/", {
                        templateUrl: '/views/ib/cms/SchoolAdminStartScreen.html',
                        controller: 'StartScreenController',
                        resolve: cmsSessionResolve
                    })
                    .when('/', {
                        redirectTo: '/cms/start/',
                    });
            } else {
                route.when('/hybrid-time', {
                    templateUrl: '/views/ib/modules/hybridTime/HybridTime.html',
                    controller: 'HybridTimeController',
                    resolve: beforeLoginResolve
                }).when('/welcome', {
                    templateUrl: '/views/ib/modules/welcome/Welcome.html',
                    controller: 'WelcomeController',
                    resolve: beforeLoginResolve
                }).when('/', {
                    redirectTo: '/pwa-start'
                })
            }

            // configure specific routes for CMS / non-CMS

            if (isCMS) {
                var sheetRoute = '/sheet/:taskUUID/:sheetUUID';
                var sheetRouteForSpecificQuestion = '/sheet/:taskUUID/:sheetUUID/:scrollToUUID/:preview';
                var preview = '/sheet/:taskUUID/:sheetUUID/:preview'
            } else {
                var sheetRoute = '/sheet/:sheetUUID';
                var sheetRouteForSpecificQuestion = '/sheet/:sheetUUID/:scrollToUUID';
            }

            route
                .when('/pwa-start', {
                    templateUrl: '/views/ib/modules/pwa/PWAStart.html',
                    //controller: 'PWAController', // the controller is now wired via the view
                    resolve: pwaStartResolve
                })
                .when('/response-support', {
                    templateUrl: '/views/ib/modules/responseSupport/ResponseSupport.html',
                    controller: 'ResponseSupportController'
                })
                .when('/login', {
                    templateUrl: '/views/ib/modules/login/Login.html',
                    controller: 'LoginController',
                    resolve: beforeLoginResolve
                })
                .when('/vm-detection', {
                    templateUrl: '/views/ib/modules/vm-detection/VMDetection.html',
                    controller: 'VMDetectionController',
                    resolve: VMDetectionResolve
                })
                .when('/user/:UserUUID', {
                    templateUrl: '/views/ib/modules/hellouser/HelloUser.html',
                    controller: 'HelloUserController',
                    resolve: helloUserResolve
                })
                .when('/instructions/:UserUUID', {
                    templateUrl: '/views/ib/modules/instructions/Instructions.html',
                    controller: 'InstructionsController',
                    resolve: instructionsResolve
                })
                .when('/overview/:taskUUID', {
                    // TODO: just for develoment!
                    templateUrl: isCMS ? '/views/ib/modules/overview/OverviewCMS.html' : '/views/ib/modules/overview/Overview.html',
                    controller: 'OverviewController',
                    resolve: duringTaskControllerResolve
                })
                .when('/pause/:taskUUID', {
                    templateUrl: '/views/ib/modules/invigilatorMenu/Pause.html',
                    controller: 'PauseController',
                    resolve: duringTaskControllerResolve
                })
                // Invigilator / Admin Menu
                .when('/invigilatorMenu/:taskUUID', {
                    // TODO: just for develoment!
                    templateUrl: '/views/ib/modules/invigilatorMenu/InvigilatorMenu.html',
                    controller: 'InvigilatorMenuController',
                    resolve: duringTaskControllerResolve
                })
                //Invigilator / Admin Menu with return to parameter
                .when('/invigilatorMenu/:taskUUID/:returnTo', {
                    // TODO: just for develoment!
                    templateUrl: '/views/ib/modules/invigilatorMenu/InvigilatorMenu.html',
                    controller: 'InvigilatorMenuController',
                    resolve: duringTaskControllerResolve
                })
                .when(sheetRoute, {
                    templateUrl: '/views/ib/modules/sheet/Sheet.html',
                    controller: 'SheetController',
                    resolve: duringTaskControllerResolve
                })
                .when(preview, {
                    templateUrl: '/views/ib/modules/sheet/Sheet.html',
                    controller: 'SheetController',
                    resolve: duringTaskControllerResolve
                })
                .when(sheetRouteForSpecificQuestion, {
                    templateUrl: '/views/ib/modules/sheet/Sheet.html',
                    controller: 'SheetController',
                    resolve: duringTaskControllerResolve
                })
                .when('/taskdone/:UserUUID', {
                    templateUrl: '/views/ib/modules/taskdone/TaskDone.html',
                    controller: 'TaskDoneController',
                    resolve: afterTaskControllerResolve
                })
                .when('/mediaassessmenttaskdone', {
                    templateUrl: '/views/ib/modules/taskdone/MediaAssessmentTaskDone.html',
                    controller: 'MediaAssessmentTaskDoneController',
                    resolve: afterTaskControllerResolve
                })
                .when('/journalOptIn/', {
                    templateUrl: '/views/ib/modules/journalOptIn/JournalOptIn.html',
                    controller: 'JournalOptInController',
                    resolve: duringTaskControllerResolve
                    //resolve: afterTaskControllerResolve
                })
                .when('/logout/', {
                    controller: 'LogoutController',
                    templateUrl: '/views/ib/cms/StartScreen.html'
                })
                .when("/cms/start/", {
                    templateUrl: '/views/ib/cms/StartScreen.html',
                    controller: 'StartScreenController',
                    resolve: cmsSessionResolve
                })
                .when("/cms/start/:redirectTo", {
                    templateUrl: '/views/ib/cms/StartScreen.html',
                    controller: 'StartScreenController',
                    resolve: cmsSessionResolve
                })
                //TODO
                .when("/school/start/", {
                    templateUrl: '/views/ib/cms/SchoolAdminStartScreen.html',
                    controller: 'StartScreenController',
                    //resolve: cmsSessionResolve
                })
                .when('/use-assessment/:assessmentUUID', {
                    resolve: {
                        sessionStorage: function ($route, $rootScope, $sessionStorage, $location) {
                            $sessionStorage.usedAssessment = $route.current.params.assessmentUUID;
                            $rootScope.isTestingMode = true;

                            if ((typeof response_data_path != 'undefined') && response_data_path) {
                                $sessionStorage.response_data_path = response_data_path;
                            }
                            if ((typeof user_data_path != 'undefined') && user_data_path) {
                                $sessionStorage.user_data_path = user_data_path;
                            }

                            $location.path('/');
                        }
                    }
                })
                .otherwise({
                    redirectTo: '/'
                });

            locationProvider.html5Mode(false);

            loadLanguage($translateProvider);
        }
    ]);


    /**
     * the following helper exists to create "computed properties" in AngularJS
     * this is e.g. used for the "mode" property of the $rootScope which
     * decides which viewing mode is currently active in the CMS
     **/
    var ngCreateComputedProperty = function ($scope, computedPropertyName, dependentProperties, func) {
        var assignFunc = function ($scope) {
            var computedVal = func($scope);
            $scope[computedPropertyName] = computedVal;
        }

        $scope.$watchCollection(dependentProperties, function (newVal, oldVal, $scope) {
            assignFunc($scope);
        });
        assignFunc($scope);
    };

    app.run(function ($translate, $rootScope, IAAPreferencesService, $signals, editableOptions, BrowserCheckService, CheckLoginService, $bridges, IFrameAPIService, TableObjectAPIService, $window, TaskDataService, $location, $sessionStorage, FreezeService, ErrorHandlerService, SessionResumeService, $timeout, PWAService, $q, ServiceWorkerHealthMonitor, ServiceWorkerUpdateController, TelemetryBeaconService) {

        /* On app load
        history.pushState(null, null, $location.absUrl());
        window.onpopstate = function() {
            // Revert navigation attempt
            history.pushState(null, null, $location.absUrl());
        };*/

        /* monkey patching $translate service
        $translate.instant = function (string) {
            return $translate(string);
        };*/

        $window.tableAPI = TableObjectAPIService;

        // Session Resume Check (for kiosk mode - automatic session restoration after refresh).
        // We attempt resume regardless of the current route: a Chromebook kiosk relaunch loses
        // the URL hash and lands on '/', which Angular redirects to '/pwa-start' via the
        // top-level `redirectTo: '/pwa-start'` rule in this file's route table. Treating that
        // as "user wants fresh start" was the bug — resume data means the candidate is
        // mid-exam, period. The failure path below clears data and routes to /pwa-start if
        // the resume turns out to be unusable.

        // A hard refresh bypasses the active SW, so navigator.serviceWorker.controller
        // is null at boot. Resume must wait for SW to take control before proceeding;
        // PWABootstrap.ready() is the canonical sync point for that.
        var noSwController = navigator.serviceWorker && !navigator.serviceWorker.controller;

        // Clear stale healthCheckRecovery flag on startup to prevent it leaking into unrelated resets
        sessionStorage.removeItem('healthCheckRecovery');

        // End-of-exam teardown: wipes session-resume storage AND runs the
        // SW-related cleanup (health monitoring stop + deferred update apply).
        // Called from both the /pwa-start $routeChangeSuccess handler AND the
        // failed-resume paths below — the latter can't rely on the route
        // handler firing, because $location.path('/pwa-start') from a session
        // already on /pwa-start does not emit $routeChangeSuccess.
        function clearExamSessionAndCleanup(reason) {
            console.log('app.js: Ending exam session (' + reason + '), clearing data + SW cleanup');
            SessionResumeService.clearResumeData();
            ServiceWorkerHealthMonitor.stopMonitoring();
            // markExamEnded is now redundant — clearResumeData wipes examInProgress
            // too via clearSessionResumeStorage — but kept for explicit telemetry.
            ServiceWorkerUpdateController.markExamEnded();
            // Forget the candidate identity so the next sitting cannot inherit it.
            // applyDeferredUpdate below only reloads when an update is pending, so the
            // Angular singletons can survive into the next candidate's session.
            try {
                TelemetryBeaconService.forgetCandidate();
            } catch (e) {
                console.warn('app.js: Could not clear telemetry candidate identity:', e);
            }
            ServiceWorkerUpdateController.applyDeferredUpdate().catch(function (err) {
                console.error('app.js: Failed to apply deferred SW update:', err);
            });
        }

        function attemptSessionResumeFlow(sessionResumeDeferred) {
            // Attempt session resume after a brief delay to allow services to initialize.
            // The deferred was created and attached to $rootScope synchronously by the
            // caller, so route resolvers already see and await it.
            $timeout(function () {
                console.log('app.js: Starting actual session resume attempt');
                SessionResumeService.attemptResume().then(function (result) {
                    console.log('app.js: Session resume result:', result);

                    if (result.success && result.route) {
                        console.log('app.js: Navigating to resumed route:', result.route);
                        sessionResumeDeferred.resolve({ success: true });
                        $location.path(result.route);
                    } else {
                        // Failed resume from a /pwa-start arrival: $location.path
                        // below is a no-op from the router's perspective (already
                        // on /pwa-start), so $routeChangeSuccess won't fire to run
                        // the cleanup branch. Run it inline instead.
                        clearExamSessionAndCleanup('resume failed');
                        sessionResumeDeferred.reject('Session resume failed');
                        $location.path('/pwa-start');
                    }
                }).catch(function (error) {
                    console.error('app.js: Session resume error:', error);
                    clearExamSessionAndCleanup('resume threw: ' + (error && error.message || error));
                    sessionResumeDeferred.reject(error);
                    $location.path('/pwa-start');
                }).finally(function () {
                    $rootScope.isResumingSession = false;
                    // Null out so subsequent route resolvers in userInfoResolverFactory
                    // don't wait on an already-settled promise.
                    $rootScope.sessionResumePromise = null;
                    if (!$rootScope.$$phase) {
                        $rootScope.$apply();
                    }
                });
            }, 100);
        }

        function preserveSessionResumeForNextRefresh(sessionResumeDeferred, reason) {
            console.log('app.js: ' + reason + ', preserving resume data for next refresh, routing to /pwa-start');
            sessionResumeDeferred.reject(reason);
            $rootScope.isResumingSession = false;
            $rootScope.sessionResumePromise = null;
            $location.path('/pwa-start');
            if (!$rootScope.$$phase) {
                $rootScope.$apply();
            }
        }

        if (!isCMS && SessionResumeService.needsSessionResume()) {
            $rootScope.isResumingSession = true;

            // CRITICAL: Create the deferred SYNCHRONOUSLY so userInfoResolverFactory
            // sees it during the very first route resolution after bootstrap, regardless
            // of whether we still have to wait for the SW controller.
            var sessionResumeDeferred = $q.defer();
            $rootScope.sessionResumePromise = sessionResumeDeferred.promise;
            console.log('app.js: sessionResumePromise created and attached to $rootScope');

            if (noSwController) {
                console.log('app.js: No SW controller, deferring resume to PWABootstrap.ready');
                PWABootstrap.ready().then(function (status) {
                    if (!status.supported) {
                        preserveSessionResumeForNextRefresh(sessionResumeDeferred, 'SW unsupported/failed');
                        return;
                    }

                    waitForServiceWorkerController(navigator.serviceWorker).then(function (hasController) {
                        if (!hasController) {
                            preserveSessionResumeForNextRefresh(sessionResumeDeferred, 'SW bootstrap completed without a controller');
                            return;
                        }

                        console.log('app.js: SW controller arrived, attempting deferred session resume');
                        attemptSessionResumeFlow(sessionResumeDeferred);
                    });
                });
            } else {
                attemptSessionResumeFlow(sessionResumeDeferred);
            }
        }

        if (!isCMS && $sessionStorage.usedAssessment) {
            $rootScope.isTestingMode = true;
        }
        if (!isCMS) {
            $rootScope.$on('$routeChangeSuccess', function (next, current) {
                $('html, body').animate({
                    scrollTop: 0
                }, 500);

                if (angular.element('.cke_dialog_background_cover').length > 0) {
                    angular.element('.cke_dialog_background_cover').hide();
                }

                // Store current route for session resume (only for resumable routes)
                if (current && current.$$route) {
                    var path = current.$$route.originalPath;

                    // Clear session resume data when arriving at /pwa-start AFTER an exam
                    // has ended. The examInProgress guard distinguishes legitimate end-of-exam
                    // navigations (Quit / Done / failed-resume — all of which flip the flag
                    // before navigating) from incidental routings into /pwa-start (e.g. a
                    // Chromebook kiosk relaunch that lost the URL hash). With the flag still
                    // 'true', preserving the resume data lets the next bootstrap auto-resume —
                    // BUT only if the payload is actually intact (key + assessmentId present
                    // and the 4h TTL hasn't elapsed). If `examInProgress` is stuck at `'true'`
                    // while the rest of the payload is gone or stale, preserving would strand
                    // the client at /pwa-start indefinitely (markExamEnded / deferred-update
                    // application would never fire), so we treat that as a cleanup case too.
                    if (path === '/pwa-start') {
                        var examInProgress = sessionStorage.getItem('examInProgress') === 'true';
                        var hasResumePayload = SessionResumeService.needsSessionResume();
                        if (!examInProgress || !hasResumePayload) {
                            var reason = !examInProgress
                                ? 'exam ended'
                                : 'examInProgress flag stale (payload missing/expired)';
                            clearExamSessionAndCleanup(reason);
                        } else {
                            console.log('app.js: On /pwa-start but exam still in progress (payload intact), preserving resume data');
                        }
                    }

                    // Only store routes that make sense to resume to
                    var resumableRoutes = ['/sheet/', '/overview/', '/instructions/', '/user/'];
                    var isResumable = resumableRoutes.some(function (route) {
                        return path && path.indexOf(route) === 0;
                    });
                    if (isResumable) {
                        // Store the actual URL path (with params filled in)
                        sessionStorage.setItem('sessionResumeRoute', $location.path());
                    }
                }

            });

            /** userUUID whose telemetry start is mid-flight, to avoid double starts. */
            var telemetryStartInFlight = null;

            // Store assessment ID when user successfully logs in
            $signals.on('tryUnlockSuccess', function (userUUID) {
                console.log('app.js: Login success, userUUID:', userUUID);

                var currentMetadata = PWAService.currentMetadata;
                if (currentMetadata && currentMetadata.id) {
                    localStorage.setItem('sessionResumeAssessmentId', currentMetadata.id.toString());
                }

                // Mark exam as in progress and start health monitoring
                ServiceWorkerUpdateController.markExamInProgress();
                ServiceWorkerHealthMonitor.startMonitoring(userUUID);

                var metadata = PWAService.currentMetadata || {};
                var telemetryUrl = PWAService.getTelemetryUrl();

                if (telemetryUrl) {
                    // One login at a time. start() is deferred behind an async lookup,
                    // so two closely spaced tryUnlockSuccess emissions would otherwise
                    // interleave into two sessionIds for a single login.
                    if (telemetryStartInFlight === userUUID) {
                        return;
                    }
                    telemetryStartInFlight = userUUID;

                    // Resolve the school code before start() so session.start itself
                    // carries it. Events recorded in the meantime are queued by
                    // TelemetryBeaconService, up to its 50-event cap, and flushed with
                    // their original timestamps once start() runs. Note that flush goes
                    // out via sendBeacon rather than through the SW collector, so it
                    // has no offline retry.
                    PWAService.resolveTelemetrySchoolCode(metadata).then(function (resolved) {
                        var schoolCode = resolved.schoolCode;
                        TelemetryBeaconService.start({
                            telemetryUrl: telemetryUrl,
                            sessionId: metadata.assessment_uuid ? (metadata.assessment_uuid + '-' + Date.now()) : ('session-' + Date.now()),
                            assessmentUuid: metadata.assessment_uuid || '',
                            userUuid: userUUID || '',
                            deviceId: '',
                            swInstanceId: '',
                            schoolCode: schoolCode,
                            packageType: metadata.package_type || '',
                            // Deliberately not set here. The candidate code must be the
                            // user file's `candidateNo` (the value ib-main joins on), and
                            // that file has not loaded yet at unlock time. It is patched
                            // in on USER_FILE_LOADED below. Using the login form's
                            // zero-filled value instead would not join for short codes.
                        });

                        TelemetryBeaconService.record('session.start', 'info', {
                            browserUA: navigator.userAgent,
                            navigatorOnline: navigator.onLine,
                            assessmentTitle: metadata.title || '',
                            // Provenance for both identity columns, so neither is ever
                            // silently ambiguous when grouping a large result set.
                            // schoolCodeSource distinguishes an unprovisioned school
                            // device from an unmanaged one; see
                            // PWAService.getProvisionedSchoolCodeReason.
                            schoolCodeSource: resolved.source,
                            candidateCodeSource: 'pending_user_file',
                        });
                    }).catch(function (error) {
                        // AngularJS 1.5 predates unhandled-rejection reporting, so
                        // without this a throw in the callback would kill telemetry for
                        // the whole session with no output anywhere.
                        console.error('app.js: Telemetry start failed', error);
                    }).finally(function () {
                        telemetryStartInFlight = null;
                    });
                }
            });

            // Supply the authoritative candidate code once the user file is decrypted.
            //
            // `candidateNo` is the raw code ib-main stores in `ib_admin.candidate_code`
            // (responsefile_processor.py:1338), which is what telemetry rows have to
            // join against. The login form's value is zero-filled to 6 chars to build
            // the unlock key (build_user_files.py:250), so it is a different string for
            // any code shorter than that and must not be used here.
            $signals.on(IB.Signals.USER_FILE_LOADED, function (candidate) {
                try {
                    if (candidate && typeof candidate.getCandidateNo === 'function') {
                        TelemetryBeaconService.setCandidateCode(candidate.getCandidateNo() || '');
                    }
                } catch (e) {
                    // Telemetry must never break the user file load
                    console.warn('app.js: Could not set telemetry candidate code:', e);
                }
            });
        }

        if (isCMS) {
            CheckLoginService.start();

            $rootScope.cmsNavigation = [
                {
                    name: 'eAssessment',
                    sub: [
                        { href: 'list', name: 'List' },
                        { href: 'create', name: 'Create' },
                        { href: 'wrap-and-deploy-list', name: 'Wrap and Deploy' },
                        { href: 'ibis-export', name: 'Ibis Export MS' }
                    ]
                },
                {
                    name: 'CMS',
                    sub: [{ href: 'logout', name: 'Logout' }]
                }
            ];
        }

        editableOptions.theme = 'bs3';

        if (isCMS && !BrowserCheckService.isSupported()) {
            $bridges.logger().error('You are using an unsupported browser. Some features may not work correctly.');
        }

        // Setup "unsaved changes" warning
        if (isCMS) {


            var showUnsavedChangesModal = function () {
                var taskContext;
                try {
                    taskContext = TaskDataService.fetchContext();
                } catch (e) {
                    return true;
                }

                if (taskContext.isDirty()) {
                    var lp = $location.path(),
                        editingPages = ["/media", "/overview", "/sheet", "/instructions"],
                        isEditingPage = false;
                    angular.forEach(editingPages, function (editingPage) {
                        if (lp.indexOf(editingPage) != -1) {
                            isEditingPage = true;
                        }
                    });

                    if (!isEditingPage) {
                        return $window.confirm("You have unsaved changes. Do you want to continue without saving?");
                    }
                }

                return true;
            };


            // When changing to a different location, show the modal
            $rootScope.$on('$locationChangeStart', function (event) {
                var confirm = showUnsavedChangesModal();
                if (!confirm)
                    event.preventDefault();
            });

            // When trying to exit the page, show modal
            $window.onbeforeunload = function (event) {
                var confirm = showUnsavedChangesModal();
                return confirm;
            }

        }

        $rootScope.$safeApply = function (fn) {
            var phase = this.$root.$$phase;
            if (phase == '$apply' || phase == '$digest') {
                if (fn && (typeof (fn) === 'function')) {
                    fn();
                }
            } else {
                this.$apply(fn);
            }
        };

        $rootScope.isPreview = false;

        $rootScope.$watch('isPreview', function () {
            $signals.emit('previewToggle');
        });

        $rootScope.isCMS = isCMS;
        $rootScope.currentFullYear = (new Date()).getFullYear();
        $rootScope.isHighlightMode = false;
        $rootScope.CMSSession = CMSSession;


        IAAPreferencesService.init();

        ngCreateComputedProperty($rootScope, 'viewMode', '[isCMS,isPreview]', function ($scope) {
            if ($scope.isCMS == true) {
                if ($scope.isPreview == true) {
                    return "preview";
                }

                return "cms";
            }

            return "assessment";
        });


        /**
         * Body set to full width size for media manager
         */
        $rootScope.$on('$routeChangeSuccess', function (ev, currentRoute, previousRoute) {
            if (isCMS == true && currentRoute.$$route.originalPath.lastIndexOf('/mediamanager', 0) === 0) {
                $('body').addClass('fullwidth-content');
            }
        });


        FreezeService.initFreezeTimeout();

        var events = [];

        /**
        rrweb.record({
          emit(event) {
              events.push(event);
              if (events.length > 10) {
                    var clonedEvents = [...events];
                    console.log("rrweb events", clonedEvents);
                    events = [];
               }
          },
        });*/

    });
})(angular, assessmentFrontendApp);

var signals = false;

angular.module("assessmentFrontendApp").value('cgBusyDefaults', {
    message: 'Processing',
    backdrop: false,
    templateUrl: '/node_modules/angular-busy/angular-busy.html',
    delay: 300,
    minDuration: 700
});

var activateScrollDownToContinue = function () {
    window.setTimeout(_activateScrollDownToContinue, 500);
};
window.activateScrollDownToContinue = activateScrollDownToContinue;

var _activateScrollDownToContinue = function () {
    var hasScrollBar = $(document).height() > $(window).height();
    if (hasScrollBar) {
        $('.scroll-down').show();
        $(window).scroll(function () {
            if ($(window).scrollTop() + $(window).height() >= $(document).height() - 10) {
                $('.scroll-down').fadeOut(300);
            } else
                $('.scroll-down').fadeIn();
        });
        $('.scroll-down').on('click', function () {
            $('body,html').animate({
                scrollTop: $(window).scrollTop() + $(window).height() - $('#top-navigation-bar').height()
            });
        });
    }
};
